import React from 'react';
import Types from 'prop-types';
import FooterTitle from './FooterTitle';
import FooterLinks from './FooterLinks';
var FooterTop = function FooterTop(_ref) {
  var sections = _ref.sections;
  return /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, sections.map(function (_ref2) {
    var titleTranslationKey = _ref2.titleTranslationKey,
      items = _ref2.items;
    return /*#__PURE__*/React.createElement("div", {
      className: "col-md-3 text-xs-center text-md-left",
      key: titleTranslationKey
    }, /*#__PURE__*/React.createElement(FooterTitle, {
      translationKey: titleTranslationKey
    }), /*#__PURE__*/React.createElement(FooterLinks, {
      items: items
    }));
  }));
};
export default FooterTop;